import { render, staticRenderFns } from "./CenterAscendingStaffList.vue?vue&type=template&id=3daae024&scoped=true&"
import script from "./CenterAscendingStaffList.vue?vue&type=script&lang=ts&"
export * from "./CenterAscendingStaffList.vue?vue&type=script&lang=ts&"
import style0 from "./CenterAscendingStaffList.vue?vue&type=style&index=0&id=3daae024&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daae024",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VContainer,VRow})
